import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';

export enum laserBoardEventsKeys {
    DRAW_LASER_CUSOR = 'DRAW_LASER_CUSOR',
    CUSOR_MOVE = 'CUSOR_MOVE'
}
export interface laserBoardEventsMap {
    [laserBoardEventsKeys.DRAW_LASER_CUSOR]: { X: number; Y: number },
    [laserBoardEventsKeys.CUSOR_MOVE]: { X: number; Y: number }
}

export enum annoationEventsKeys {
    SPEAKER_BOARD_MESSAGE = 'speaker-board-message',
    CLIENT_BOARD_MESSAGE = 'client-board-message',
    SCALE = 'scale'
}
export interface annoationEventsMap {
    [annoationEventsKeys.SPEAKER_BOARD_MESSAGE]: { [key: string]: any },
    [annoationEventsKeys.CLIENT_BOARD_MESSAGE]: { [key: string]: any },
    [annoationEventsKeys.SCALE]: { scale: number, pivotX: number, pivotY: number }
}

export const laserBoardEventBus: IEventEmitter<laserBoardEventsMap> = new EventBus();
export const annoationEventBus: IEventEmitter<annoationEventsMap> = new EventBus();
